import { HttpClient } from '@angular/common/http';
import { APIBaseManager } from '../../../api.base';

export class APIListVirtualDeviceLabelManager extends APIBaseManager<void, void, void, string[]> {
    constructor(protected http: HttpClient) {
        super(http);
        this._apiName = 'API_ListVirtualDeviceLabel';
        this._apiMethod = 'GET';
    }

    protected getRequestURL(pathParameters: void, queryParameters: void): string {
        return super.getRequestURL() + 'virtualDevices/labels';
    }
}